import {Component, OnInit, Input, EventEmitter, Output, OnChanges, DoCheck} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {ProjectDialogComponent} from '@common-components/project-dialog/project-dialog.component';
import {Globals} from "@app/services/globals.service";
import {ConstantsService} from "@app/services/constants/constants.service";

@Component({
    selector: 'app-project-select',
    templateUrl: './project-select.component.html',
    styleUrls: ['./project-select.component.css']
})
export class ProjectSelectComponent implements OnInit {
    @Input() form: FormGroup;
    @Input() checkIfInvalidInput;
    @Input() projects;
    @Input() emptyProject;
    @Input() forma: EventEmitter<any> = new EventEmitter<any>();
    @Input() dataForEdit: EventEmitter<any> = new EventEmitter<any>();
    @Input() isDisabled: boolean;
    @Output() outputToParent = new EventEmitter<any>();

    project = new FormControl();
    validProject;
    searchText = '';
    filteredProjects = [];

    buttonText = 'Projekat';

    addButtonDisabled = false;


    constructor(public dialog: MatDialog,
                public taskServce: TaskService,
                private globals: Globals,
                private constantsService: ConstantsService) {
    }

    ngOnInit(): void {
        this.addButtonDisabled = (this.constantsService.admins.indexOf(this.constantsService.getLoggedInUserId()) == -1);

        this.taskServce.getProjects().subscribe(data => {
            this.projects = data;
            this.filteredProjects = this.projects;
        });
        if (this.dataForEdit !== undefined) {
            if (this.dataForEdit['project'] !== undefined && this.dataForEdit['project'] !== null) {
                this.searchText = this.dataForEdit['project']['name'];
                this.buttonText = this.dataForEdit['project']['name'];
            }
        } else {
            this.searchText = '';
        }
    }

    ngOnChanges() {
        this.ngOnInit();
    }


    setProject(project) {
        this.outputToParent.emit(project);
    }

    checkIsValid() {
        this.searchText = '';
        this.outputToParent.emit({});

    }


    set() {
        const obj = this.projects.find(o => o.name === this.searchText);
        if (obj === undefined) {
            if (this.taskServce.taskProject !== undefined) {
                this.project.setValue(this.taskServce.taskProject);
                this.searchText = this.taskServce.taskProject.name;
            }
        }


    }


    onClick() {
        if (this.addButtonDisabled) return;
        this.dialog.open(ProjectDialogComponent, {
            disableClose: true,
            height: '20%'
        }).afterClosed().subscribe(() => {
            this.taskServce.getProjects().subscribe(result => {
                this.projects = result;
            });
        });
    }

    filterProjects(event) {
        if (event.key !== '') {
            this.filteredProjects = this.projects.filter(x => x.name.includes(this.searchText));
        } else {
            this.filteredProjects = this.projects;
        }

    }

    onMenuOpened() {

    }

}
